export default __webpack_public_path__ + "static/media/logoNBS-black.4578b537.svg";